<template>
<div :class="{heightPc:$mq==='pc'}">
  <v-card-text class="text-center voteSetTitle py-4 text-h5" style="color:#ffffff;">投票<span v-if="voteSet">開始</span>設定をする</v-card-text>
  <v-container class="pa-0 overflow-y-auto" style="height:72vh;">
    <div class="d-flex align-center justify-center">
      <p class="text-center my-2" v-if="voteSetEdit">投票期間中は投票終了日時のみ変更できます</p>
    </div>
    <v-card-text class="text-left py-2 text-h6 font-weight-bold" style="color:#BA0009;" width="100%">投票期間</v-card-text>
    <v-card-text class="text-left py-0 text-caption" style="color:#2B2B2B;">投票期間を設定してください</v-card-text>
    <v-card-text class="text-center pt-2" style="color:red;" v-if="voteSetAtString() < now_mi">日付を正しく設定してください</v-card-text>
    <v-card class="ma-2 px-2 py-2" elevation="0" style="border-radius: 2px; background-color:#DCDCDC;">
      <h4 class="mb-2 font-weight-light text-center" style="color:#2b2b2b;">投票開始日時</h4>
      <v-radio-group v-model="isVoteStartTime" mandatory class="mt-0 pt-0" :disabled="voteSetEdit">
        <v-radio label="即時開始" value="startnow" class="text-body-1"></v-radio>
        <v-radio label="開始日時" value="startlater" class="text-body-1"></v-radio>
      </v-radio-group>
      <div class="px-2 py-0 mx-auto d-flex" style="width:100%;" v-if="voteSet">
        <v-select class="text-caption py-0" :items="years" v-model="voteStartYYYY" label="年" :disabled="isVoteStartTime!=='startlater'||voteSetEdit"></v-select>
        <v-select class="text-caption py-0" :items="months" v-model="voteStartMO" label="月" :disabled="isVoteStartTime!=='startlater'||voteSetEdit"></v-select>
        <v-select class="text-caption py-0" :items="ddddd" v-model="voteStartDD" label="日" :disabled="isVoteStartTime!=='startlater'||voteSetEdit"></v-select>
        <v-select class="text-caption py-0" :items="hours" v-model="voteStartHH" label="時" :disabled="isVoteStartTime!=='startlater'||voteSetEdit"></v-select>
        <v-select class="text-caption py-0" :items="minutes" v-model="voteStartMI" label="分" :disabled="isVoteStartTime!=='startlater'||voteSetEdit"></v-select>
      </div>
      <div class="px-2 py-0 mx-auto d-flex justify-center" style="width:100%; color:#707070;" v-else-if="voteSetEdit">
        <p class="py-0">{{voteStartYYYY}}年 {{voteStartMO}}月{{voteStartDD}}日 {{voteStartHH}}時{{voteStartMI}}分</p>
      </div>
    </v-card>
    <v-card class="ma-2 px-2" elevation="0" style="border-radius: 2px; background-color:#DCDCDC;">
      <h4 class="font-weight-light text-center" style="color:#2b2b2b;">投票終了日時</h4>
      <div class="px-2 pt-6 mx-auto d-flex" style="width:100%;">
        <v-select class="text-caption py-0" :items="years" v-model="voteEndYYYY" label="年"></v-select>
        <v-select class="text-caption py-0" :items="months" v-model="voteEndMO" label="月"></v-select>
        <v-select class="text-caption py-0" :items="ddddd" v-model="voteEndDD" label="日"></v-select>
        <v-select class="text-caption py-0" :items="hours" v-model="voteEndHH" label="時"></v-select>
        <v-select class="text-caption py-0" :items="minutes" v-model="voteEndMI" label="分"></v-select>
      </div>
    </v-card>

    <v-card-text class="text-left py-2 mt-6 text-h6 font-weight-bold" style="color:#BA0009;" width="100%">投票内容の設定</v-card-text>
    <v-card-text class="text-left pt-0 text-caption" style="color:#2B2B2B;">投票内容をカスタマイズしてください</v-card-text>
    <v-row class="mx-4">
      <v-select :items="selectoption" v-model="voteType" label="選択肢" :disabled="voteSetEdit"></v-select>
    </v-row>
    <v-row class="mx-4">
      <v-text-field v-model="voteOptions[0]" label="選択肢1(10字以内)" single-line outlined v-if="voteType==='自由選択肢'" :disabled="voteSetEdit"></v-text-field>
      <v-text-field v-model="voteOptions[1]" label="選択肢2(10字以内)" single-line outlined v-if="voteType==='自由選択肢'" :disabled="voteSetEdit"></v-text-field>
      <v-card-text class="text-right pa-0" style="color:#008cff" @click="addChoice1 = true" v-if="voteType==='自由選択肢'&&!addChoice1">＋選択肢を追加</v-card-text>
      <v-text-field v-model="voteOptions[2]" label="選択肢3(10字以内)" single-line outlined v-if="voteType==='自由選択肢'&&addChoice1&&!voteSetEdit" :disabled="voteSetEdit"></v-text-field>
      <v-card-text class="text-right pa-0" style="color:#008cff" @click="addChoice2 = true" v-if="addChoice1&&!addChoice2&&!voteSetEdit">＋選択肢を追加</v-card-text>
      <v-text-field v-model="voteOptions[3]" label="選択肢4(10字以内)" single-line outlined v-if="voteType==='自由選択肢'&&addChoice2" :disabled="voteSetEdit"></v-text-field>
      <v-card-text class="text-right pa-0" style="color:#008cff" @click="addChoice3 = true" v-if="addChoice2&&!addChoice3&&!voteSetEdit">＋選択肢を追加</v-card-text>
      <v-text-field v-model="voteOptions[4]" label="選択肢5(10字以内)" single-line outlined v-if="voteType==='自由選択肢'&&addChoice3" :disabled="voteSetEdit"></v-text-field>
      <v-card-text class="text-right pa-0" style="color:#008cff" @click="addChoice4 = true" v-if="addChoice3&&!addChoice4&&!voteSetEdit">＋選択肢を追加</v-card-text>
      <v-text-field v-model="voteOptions[5]" label="選択肢6(10字以内)" single-line outlined v-if="voteType==='自由選択肢'&&addChoice4" :disabled="voteSetEdit"></v-text-field>
      <v-card-text class="text-right pa-0" style="color:#008cff" @click="addChoice5 = true" v-if="addChoice4&&!addChoice5&&!voteSetEdit">＋選択肢を追加</v-card-text>
      <v-text-field v-model="voteOptions[6]" label="選択肢7(10字以内)" single-line outlined v-if="voteType==='自由選択肢'&&addChoice5" :disabled="voteSetEdit"></v-text-field>
      <v-card-text class="text-right pa-0" style="color:#008cff" @click="addChoice6 = true" v-if="addChoice5&&!addChoice6&&!voteSetEdit">＋選択肢を追加</v-card-text>
      <v-text-field v-model="voteOptions[7]" label="選択肢8(10字以内)" single-line outlined v-if="voteType==='自由選択肢'&&addChoice6" :disabled="voteSetEdit"></v-text-field>
      <v-card-text class="text-right pa-0" style="color:#008cff" @click="addChoice7 = true" v-if="addChoice6&&!addChoice7&&!voteSetEdit">＋選択肢を追加</v-card-text>
      <v-text-field v-model="voteOptions[8]" label="選択肢9(10字以内)" single-line outlined v-if="voteType==='自由選択肢'&&addChoice7" :disabled="voteSetEdit"></v-text-field>
      <v-card-text class="text-right pa-0" style="color:#008cff" @click="addChoice8 = true" v-if="addChoice7&&!addChoice8&&!voteSetEdit">＋選択肢を追加</v-card-text>
      <v-text-field v-model="voteOptions[9]" label="選択肢10(10字以内)" single-line outlined v-if="voteType==='自由選択肢'&&addChoice8" :disabled="voteSetEdit"></v-text-field>
    </v-row>
    <v-card-text class="text-left py-2 text-h6 font-weight-bold" style="color:#BA0009;" width="100%">投票形式の詳細設定</v-card-text>
    <v-card-text class="text-left pt-0 text-caption" style="color:#2B2B2B;">投票形式をカスタマイズしてください</v-card-text>
    <v-row class="ml-12">
      <v-col class="py-0">
        <v-switch v-model="isAdmitMulti" label="複数選択を認める" class="my-0" :disabled="voteType!=='自由選択肢'||voteSetEdit"></v-switch>
      </v-col>
    </v-row>
    <v-row class="ml-12">
      <v-col class="py-0" height="10">
        <v-switch v-model="isAdmitDele" label="委任投票を認める" class="my-0" :disabled="voteSetEdit"></v-switch>                      
      </v-col>
    </v-row>
    <v-row class="ml-12">
      <v-col class="py-0" height="10">
        <v-switch v-model="isAdmitQuad" label="クアドラティック投票を行う" class="my-0" :disabled="voteSetEdit"></v-switch>                      
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-radio-group v-model="isAdmitOpen" mandatory row class="ml-12" :disabled="voteSetEdit">
          <v-radio label="公開投票" value="open"></v-radio>
          <v-radio label="匿名投票" value="private"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center pt-0">
        <v-btn class="mx-4 px-12 mt-2 text-h6 font-weight-bold white--text" @click="$emit('voteStartReset')" color="#707070">設定を中断する</v-btn>
        <v-btn class="mx-4 px-16 mt-2 text-h6 font-weight-bold white--text" @click="confirmVoteset=true" color="#008cff" :disabled="(voteSet&&(voteOptions.length > 10||voteOptions.length<2))">設定完了</v-btn> 
        <v-btn class="mx-4 px-16 mt-8 text-h6 font-weight-bold white--text" @click="confirmVoteEnd=true" color="#ba0009" v-if="voteSetEdit">投票終了</v-btn>                      
        <v-card-text v-if="voteSet&&voteType==='自由選択肢'&&voteOptions.length<2" class="text-center">自由選択肢を2つ以上設定してください</v-card-text>
      </v-col>
    </v-row>
  </v-container>

  <!--投票実施確認画面-->
  <v-dialog v-model="confirmVoteset" persistent width="60%" class="z1000">
    <v-card class="pa-4">
      <v-card-text class="text-center pt-8 px-8 py-2 text-h4 font-weight-bold" style="color:#0F0101;" v-if="!voteSetEdit">
        <v-img class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
        現在の投票設定を保存しますか?
      </v-card-text>
      <v-card-text class="text-center pt-8 px-8 py-2 text-h5 font-weight-bold" style="color:#0F0101;" v-else>
        <v-img class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
        投票設定を更新しますか？
      </v-card-text>
      <v-card-text class="text-center px-8 pb-2 font-weight-bold" style="color:#0F0101;" v-if="voteSet">（<span style="color:#E64550;">投票を「即時開始する」に設定した場合、投票開始されます</span>）</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-chip class="mt-4 mx-2 px-4" color="#E64550" @click="confirmVoteset=false" dark>再設定</v-chip>
        <v-chip class="mt-4 mx-2 px-4" color="#66baff" @click="confirmVoteset=false, $emit('iseditpj', false),Votesetupdated=true,updateVote()" dark v-if="voteSetEdit">更新</v-chip>
        <v-chip class="mt-4 mx-2 px-6" @click="confirmVoteset=false,setVote()" color="#008cff" dark v-else>保存</v-chip>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--投票設定更新後画面-->
  <v-dialog v-model="Votesetupdated" persistent width="60%" class="z1000">
    <v-card class="pa-4">
      <v-card-text class="text-center pt-8 px-8 py-2 text-h5 font-weight-bold" style="color:#0F0101;">
        投票設定を更新しました
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-chip class="mt-4 mx-2 px-4" color="#66BAFF" @click="Votesetupdated=false,$emit('iseditpj', false),reload()" dark>確認</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>  

  <!--投票実施通知画面-->
  <v-dialog v-model="noticeVoteset" persistent width="60%" class="z1000">
    <v-card class="pt-4 pb-2">
      <v-card-text class="text-center px-8 py-2 pt-6 text-h5 font-weight-bold" style="color:#0F0101;" v-if="!votestartByTimepassed">投票設定が完了しました</v-card-text>
      <v-card-text class="text-center px-8 py-2 pt-6 text-h5 font-weight-bold" style="color:#0F0101;" v-else>新しい投票が開始されました</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-chip class="mt-4 mx-2 px-6" @click="noticeVoteset = false ,votestartByTimepassed = false,reload()" color="#66BAFF" dark> 確認</v-chip>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--投票終了確認画面-->
  <v-dialog v-model="confirmVoteEnd" width="60%" class="z1000">
    <v-card class="pa-4">
      <v-card-text class="text-center pt-8 px-8 py-2 text-h5 font-weight-bold" style="color:#0F0101;">
        <v-img class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
        投票を締め切りますか？
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-chip class="mt-4 mx-2 px-4" color="#66baff" @click="confirmVoteEnd=false, $emit('voteFinish')" dark>はい</v-chip>
        <v-chip class="mt-4 mx-2 px-4" color="#E64550" @click="confirmVoteEnd=false" dark> いいえ</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--Lid参加確認画面-->
<v-dialog v-model="LidSankaAlert" width="800" class="z1000">
  <v-card elevation="15" class="pt-6">
    <v-card-actions class="d-flex justify-center align-center">
      <v-img class="mr-4" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
      <div>
        <p class="font-weight-bold text-h5 text-center">あなたはこのLidに参加していません。</p>
        <p class="font-weight-bold text-h5 text-center mb-0">このLidに参加しますか？</p>        
      </div>
    </v-card-actions>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false" >参加しない</v-chip>
      <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false, this.$store.dispatch('inLid',{lidId:this.$route.params.id,uid:this.uid})" color="deepAqua" dark>参加</v-chip>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-dialog>
</div>
</template>

<script>
import Vue from 'vue'
import firebase from "firebase/app"
import "firebase/firestore"
import VueDOMPurifyHTML from 'vue-dompurify-html'
Vue.use(VueDOMPurifyHTML)
export default{
  mounted(){
    this.db = firebase.firestore() // dbインスタンスを初期化
    this.voteSetting()
  },
  props:{
    pjuid: String,
    voteSetEdit: Boolean,
    voteSet: Boolean,
    voteStartTime: Object,
    voteEndTime: Object,
    voteId: String,
    isAdmitDele: Boolean,
    isAdmitQuad: Boolean,
    isAdmitMulti: Boolean,
    isAdmitOpen: String
  },
  data: (vm) => ({
    db: null,
    offsetTop: 0,
    ddddd: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
    now_ms: null,
    now_mi: null,
    //dialog
    noticeVoteend: false,
    confirmVoteset: false,
    confirmVoteEnd: false,
    Votesetupdated: false,   
    LidSankaAlert: false,

    //vote set
    isVoteStartTime: "startnow",

    //vote
    voteType: "賛成・反対",
    voteOptions: ["賛成","反対"],
    selectoption: ['賛成・反対','自由選択肢'],
    voteStartYYYY: '',
    voteStartMO: '',
    voteStartDD: '',
    voteStartHH: '',
    voteStartMI: '',    
    voteEndYYYY: '',
    voteEndMO: '',
    voteEndDD: '',
    voteEndHH: '',
    voteEndMI: '',
    years: [2022,2023,2024],
    months: [1,2,3,4,5,6,7,8,9,10,11,12],
    day_31: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
    day_30: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30],
    day_29: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29],
    day_28: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28],
    hours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
    minutes: ['00', '15','30', '45'],
    userChoice0: {
      option1: 0,
      option2: 0,
      option3: 0,
      option4: 0,
      option5: 0,
      option6: 0,
      option7: 0,
      option8: 0,
      option9: 0,
      option10: 0,
      isDoDele: false,
      deleTo: ""
    },
    noticeVoteset:false,
    addChoice1:false,
    addChoice2:false,
    addChoice3:false,
    addChoice4:false, 
    addChoice5:false,
    addChoice6:false,
    addChoice7:false,
    addChoice8:false,

    votestartByTimepassed: false,
    chartData: {
      labels: [],
      datasets: [
        {
          label: 'Sample1',
          data:[],
          backgroundColor: [
            '#008CFF',
            '#399942',
            '#E64550',
            '#E05922',
            '#99d1ff',
            '#6eff66',
            '#ff66ba',
            '#ffab66',
            '#993d70'
          ],
          borderColor: [
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc'
          ],
          borderWidth: 1
        }
      ]
    },
  }),
  watch:{
    //日付調整
    voteStartMO:{ //月によって変わる日数の調整
      handler: function(val, oldVal) {
        let v = val.toString()
        if(v==="4"||v==="6"||v==="9"||v==="11"){
          this.ddddd = this.day_30
          if(this.voteStartDD>30){
            this.voteStartDD = 30
          }
        }
        else if(v==="2"){
          if(this.voteEndYYYY%4===0){
            this.ddddd = this.day_29
          }
          else{
            this.ddddd = this.day_28
          }
          if(this.voteStartDD>28){
            this.voteStartDD = 28
          }
        }
        else{
          this.ddddd = this.day_31
        }
      },
      deep: true,
      immediate: false
    },
    voteStartYYYY:{ //年によって変わる２月の日数調整。上と似てるが消さない
      handler: function(v, oldVal) {
        if(v%4===0){
          if(this.voteStartMO===2) this.ddddd = this.day_29
        }
        else{
          if(this.voteStartMO===2){
            this.ddddd = this.day_28
            if(this.voteStartDD>28) this.voteStartDD = 28
          }
        }
      }
    },
    voteEndMO:{ //月によって変わる日数の調整
      handler: function(val) {
        let v = val.toString()
        if(v==="4"||v==="6"||v==="9"||v==="11"){
          this.ddddd = this.day_30
          if(this.voteEndDD>30){
            this.voteEndDD = 30
          }
        }
        else if(v==="2"){
          if(this.voteEndYYYY%4===0){
            this.ddddd = this.day_29
          }
          else{
            this.ddddd = this.day_28
          }
          if(this.voteEndDD>28){
            this.voteEndDD = 28
          }
        }
        else{
          this.ddddd = this.day_31
        }
      },
      deep: true,
      immediate: false
    },
    voteEndYYYY:{ //年によって変わる２月の日数調整。上と似てるが消さない
      handler: function(v) {
        if(v%4===0){
          if(this.voteEndMO===2) this.ddddd = this.day_29
        }
        else{
          if(this.voteEndMO===2){
            this.ddddd = this.day_28
            if(this.voteEndDD>28) this.voteEndDD = 28
          }
        }
      }
    },
    voteStartTime:{
      handler(v){
        //console.log("votestarttime",v)
        this.voteSetting()
      }
    }
  },
  computed:{
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    pjusers(){
      return this.$store.state.pjusers
    },
    aboutLid() {
      return this.$store.state.aboutLid
    },
  },
  methods: {
    toDoubleDigits(num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num; 
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayy = yyyy + mm + dd + hh + mi + se + ms
      this.timeday= mm+"/"+dd
      this.timehour= hh+":"+mi
    },

    setVote(){ //投票設定// 投票開始
      //console.log("投票手続き中 投票手続対象uid:",this.pjuid,"対象Lid:",this.$route.params.id)
      let self = this
      this.today()
      if(this.isAdmitQuad) this.voteType = "quad" //クアドラ投票にする場合
      const setvoteStartTime = new Date(self.voteStartYYYY, self.voteStartMO - 1,self.voteStartDD,self.voteStartHH,self.voteStartMI) //投票開始設定で設定した投票開始日時（最初は投票開始設定を押した日時）
      const setvoteEndTime = new Date(self.voteEndYYYY, self.voteEndMO - 1,self.voteEndDD,self.voteEndHH,self.voteEndMI) //投票開始設定で設定した投票終了日時
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection("votes").add({
        author: this.uid, //作者
        createdAt: firebase.firestore.FieldValue.serverTimestamp(), //作成時間（不変）
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(), //更新時間（随時更新）
        voteType: this.voteType, //選択肢の種類
        voteOptions: this.voteOptions, //選択肢名
        isAdmitMulti: this.isAdmitMulti, //複数選択を認めるか否か
        isAdmitDele: this.isAdmitDele, //委任投票を認めるか否か
        isAdmitQuad:this.isAdmitQuad, //クアドラティック投票にするかどうか
        isAdmitOpen: this.isAdmitOpen, //公開投票にするかどうか
        voteStartAt:  firebase.firestore.Timestamp.fromDate(setvoteStartTime),// 投票開始時刻
        voteEndAt: firebase.firestore.Timestamp.fromDate(setvoteEndTime),  // 投票終了時刻
        isVoteStart: true, //投票開始日時を設定中
        //isVoteEnd: true, //投票終了日時を設定中
        isVoteFinished: false, //投票終了日時を設定中
        options: {
          n1: [],
          n2: [],
          n3: [],
          n4: [],
          n5: [],
          n6: [],
          n7: [],
          n8: [],
          n9: [],
          n10: [],
        },
        optionsDele: {
          n1: [],
          n2: [],
          n3: [],
          n4: [],
          n5: [],
          n6: [],
          n7: [],
          n8: [],
          n9: [],
          n10: [],
        },
      }).then(function(docRef) {
        // これ↓動かなかったのでコメント
        //console.log("votes Document written with ID: ", docRef.id)
        let vId = docRef.id
        //console.log("vote",vId)
        self.pjusers.forEach((el) => {
          //console.log("投票ユーザー：",el)
          self.db.collection("0").doc(self.$route.params.id).collection("project").doc(self.pjuid).collection("votes").doc(vId).collection("voteusers").doc(el.uid).set({
            uid: el.uid,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            userChoice: self.userChoice0
          }).then(function(docRef) {
            //console.log("USERs Document written with ID: ", docRef.id)
            //console.log("voteユーザ登録完了")
          }).catch(function(error) {
            console.error("voteユーザ登録失敗: ", error)
            alert("Error!:"+error)
          })
        })
        if(self.isVoteStartTime=="startnow"){
          self.votestart(self.pjuid) //投票開始
        }
        else{
          self.db.collection("0").doc(self.$route.params.id).collection("project").doc(self.pjuid).set({
            isStartVote: true,        
            updatedAt: firebase.firestore.FieldValue.serverTimestamp()
          },{merge:true})
        }
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("votes Error adding document: ", error)
        alert("投票開始設定中にエラーが発生しました。もう一度やり直すか、管理者にお問い合わせください。エラー内容:"+error)
      })
    },
    votestart(votepjuid){ //投票開始
      const self = this
      //console.log("vote start:"+votepjuid)
      self.db.collection("0").doc(self.$route.params.id).collection("project").doc(votepjuid).update({
        condition: "voting",
        isStartVote: false,        
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      })
      this.editpj = false
      this.noticeVoteset = true
      //console.log("投票を開始")
    },
    updateVote(){ //投票設定// 投票開始
      //console.log("投票更新手続き中 投票手続対象uid:",this.pjuid,"対象Lid:",this.$route.params.id)
      let self = this
      this.today()
      const setvoteEndTime = new Date(self.voteEndYYYY, self.voteEndMO - 1,self.voteEndDD,self.voteEndHH,self.voteEndMI) //投票開始設定で設定した投票終了日時
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection("votes").doc(this.voteId).update({
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(), //更新時間（随時更新）
        //isAdmitOpen: this.isAdmitOpen, //公開投票にするかどうか
        voteEndAt: firebase.firestore.Timestamp.fromDate(setvoteEndTime),  // 投票終了時刻
      }).then(function(docRef) {
        // これ↓動かなかったのでコメント
        //console.log("votes Document written with ID: ", docRef.id)
        //console.log("voteupdate",self.voteId)
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("votes Error adding document: ", error)
        alert("投票開始設定中にエラーが発生しました。もう一度やり直すか、管理者にお問い合わせください。エラー内容:"+error)
      })
    },

    //投票時間関係
    voteSetAtString(){ //投票開始設定における投票終了日時設定
      return this.voteEndYYYY.toString() + this.toDoubleDigits(this.voteEndMO.toString()) + this.toDoubleDigits(this.voteStartDD.toString()) + this.toDoubleDigits(this.voteStartHH.toString()) + this.toDoubleDigits(this.voteStartMI.toString())
    },
    voteSetting(){ //投票設定開始の準備をする関数
      let self = this
      let date = new Date()
      this.voteStartYYYY = date.getFullYear()
      this.voteStartMO = date.getMonth() + 1
      this.voteStartDD = date.getDate()
      this.voteStartHH = date.getHours()
      this.voteStartMI = "00" //this.toDoubleDigits(date.getMinutes())
      this.voteEndYYYY = this.voteStartYYYY + 1
      this.voteEndMO = this.voteStartMO
      this.voteEndDD = this.voteStartDD
      this.voteEndHH = this.voteStartHH
      this.voteEndMI = "00"
      if(self.voteStartTime){
        self.voteStartYYYY = self.voteStartTime.toDate().getFullYear()
        self.voteStartMO = self.voteStartTime.toDate().getMonth() + 1
        self.voteStartDD = self.voteStartTime.toDate().getDate()
        self.voteStartHH = self.voteStartTime.toDate().getHours()
        self.voteStartMI = self.voteStartTime.toDate().getMinutes()        
      }
      if(self.voteEndTime){
        self.voteEndYYYY = self.voteEndTime.toDate().getFullYear()
        self.voteEndMO = self.voteEndTime.toDate().getMonth() + 1
        self.voteEndDD = self.voteEndTime.toDate().getDate()
        self.voteEndHH = self.voteEndTime.toDate().getHours()
        self.voteEndMI = self.voteEndTime.toDate().getMinutes()  
        if(self.voteEndYYYY < new Date().getFullYear()) self.voteEndYYYY = new Date().getFullYear()
        if((self.voteEndTime.toDate().getMinutes())%15 !== 0 || self.voteEndTime.toDate().getMinutes() == 0) self.voteEndMI = "00"
        else self.voteEndMI = self.voteEndMI.toString()      
      }
    },  
    reload(){
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    }
  }
}
</script>

<style scoped>
.heightPc{
  max-height:80vh; 
  width:100%;
  overflow:hidden scroll;
}
.voteSetTitle{
  width:100%;
  background-color: #BA0009;
  color:white;
  font-weight: 700;
}
*{
  font-family:mplus-2c-medium;
}
::-webkit-scrollbar {
  display: none;
}
/*
::-webkit-scrollbar-track {
background-color: rgba(120, 170, 210,0.3);
border-radius: 100px;
}
::-webkit-scrollbar-thumb {
background: #78aad2;
border-radius: 100px;
width: 130px;
}
*/
</style>